import { CaptionMarkdown } from './CaptionMarkdown';
import type { CaptionTone } from './CaptionMarkdown';

const TONE_CLASS = {
  default: 'text-neutral-500',
  inverse: 'text-white/60',
} as const;

interface HeroCaptionProps {
  /** Markdown credit line, e.g. `Photo by [Jane Doe](https://…) on [Unsplash](https://…)`. */
  caption: string;
  /** Surface the caption sits on. `inverse` is the marketing hero's photograph. */
  tone?: CaptionTone;
  className?: string;
}

/**
 * The credit line under a hero image, small and right-aligned.
 *
 * Hero credits need more than one link — Unsplash asks you to credit both the
 * photographer and Unsplash itself — so the caption is stored as markdown and
 * `CaptionMarkdown` renders the links.
 */
export function HeroCaption({ caption, tone = 'default', className = '' }: HeroCaptionProps) {
  return (
    <figcaption className={`text-xs text-right ${TONE_CLASS[tone]} ${className}`}>
      <CaptionMarkdown caption={caption} tone={tone} />
    </figcaption>
  );
}
